module.exports = __webpack_public_path__ + "static/media/comment-alt-dollar.6f6f37ae.svg";